"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _contextTypes = _interopRequireDefault(require("../context-types"));

var _utils = require("../lib/utils");

var _tokenManager = _interopRequireDefault(require("./token-manager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  debug: {
    position: 'absolute',
    top: 5,
    right: 5,
    background: '#b1d85da8',
    padding: 10
  }
};

var Debug =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Debug, _React$Component);

  function Debug() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Debug);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Debug)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: true
    });

    return _this;
  }

  _createClass(Debug, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          contextProps = _this$props.contextProps,
          contextState = _this$props.contextState,
          hashValues = _this$props.hashValues; // we remove the loggingInIndicator from the props we show, as JSON.stringify fails
      // otherwise

      var loggingInIndicator = contextProps.loggingInIndicator,
          otherContextProps = _objectWithoutProperties(contextProps, ["loggingInIndicator"]);

      if (!this.state.open) {
        return null;
      }

      return _react["default"].createElement("div", {
        style: styles.debug
      }, _react["default"].createElement("button", {
        onClick: function onClick() {
          return _this2.setState({
            open: false
          });
        }
      }, "close"), _react["default"].createElement("ul", null, _react["default"].createElement("li", null, "contextProps=", JSON.stringify(otherContextProps)), _react["default"].createElement("li", null, "contextState=", JSON.stringify(contextState)), _react["default"].createElement("li", null, "hashValues=", JSON.stringify(hashValues))));
    }
  }]);

  return Debug;
}(_react["default"].Component);

var AuthContext =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(AuthContext, _React$Component2);

  function AuthContext() {
    var _getPrototypeOf3;

    var _this3;

    _classCallCheck(this, AuthContext);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(AuthContext)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this3), "isDebugEnabled", function () {
      return !!(localStorage.getItem('debug') || '').match(/react-u5auth/);
    });

    return _this3;
  }

  _createClass(AuthContext, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this$props2 = this.props,
          provider = _this$props2.provider,
          clientId = _this$props2.clientId,
          loggingInIndicator = _this$props2.loggingInIndicator;
      return {
        provider: provider,
        clientId: clientId,
        loggingInIndicator: loggingInIndicator
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var state = (0, _utils.getHashValues)().state;
      var showChildren = !(state && state.match(/^refreshing/));

      var _this$props3 = this.props,
          children = _this$props3.children,
          _onTokenUpdate = _this$props3.onTokenUpdate,
          contextProps = _objectWithoutProperties(_this$props3, ["children", "onTokenUpdate"]);

      var debug = this.isDebugEnabled();
      console.log('react-u5auth, debug', debug);
      return _react["default"].createElement("div", null, _react["default"].createElement(_tokenManager["default"], {
        onTokenUpdate: function onTokenUpdate(token) {
          _this4.setState({
            token: token
          });

          _onTokenUpdate && _onTokenUpdate(token);
        }
      }), debug && _react["default"].createElement(Debug, {
        contextProps: contextProps,
        contextState: this.state,
        hashValues: state
      }), showChildren && this.props.children);
    }
  }]);

  return AuthContext;
}(_react["default"].Component);

exports.AuthContext = AuthContext;
AuthContext.propTypes = _contextTypes["default"];
AuthContext.childContextTypes = _contextTypes["default"];
//# sourceMappingURL=auth-context.js.map